export enum TenantListActionsConst {
  GET_ACCESSIBLE_TENANT_LIST = "GET_ACCESSIBLE_TENANT_LIST",
  GET_ACCESSIBLE_TENANT_LIST_SUCCESS = "GET_ACCESSIBLE_TENANT_LIST_SUCCESS",
  GET_ACCESSIBLE_TENANT_LIST_FAIL = "GET_ACCESSIBLE_TENANT_LIST_FAIL",
}
